module.exports = __webpack_public_path__ + "static/img/yytx38.b29158a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx38.png
// module id = 816
// module chunks = 0